<template>
  <div class="toasts">
    <div
      v-for="t in toasts.list"
      :key="t.id"
      class="toast"
      :class="t.kind"
      @click="toasts.remove(t.id)"
    >
      <p class="headline">{{ t.text }}</p>
      <p v-if="t.description" class="description">({{ t.description }})</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast'
const toasts = useToastStore()
</script>

<style scoped lang="scss">
.toasts {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 1000;
}
.toast {
  background: var(--color-background);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  &.success {
    border-color: rgba(39, 174, 96, 0.5);
  }
  &.warning {
    border-color: rgba(230, 126, 34, 0.5);
  }
  &.error {
    border-color: rgba(192, 57, 43, 0.5);
  }
  .description {
    font-size: 0.85rem;
    opacity: 0.7;
    margin-left: 0.5rem;
  }
}
</style>
